import APIKit from "api/api/axiosSetup";
import { errorHandler } from "api/api/errorHandler";
import useSWR from "swr";
import { UTILS } from "utils";

const timeout = 60 * 1000;
const CreateCreatifyLinkWithParams = async (payload) => {
  try {
    APIKit.defaults.timeout = timeout;
    const response = await APIKit.post(
      "creatify-api/create-link-with-params",
      payload
    );
    if (response?.data?.success === 1) {
      return response?.data?.data;
    }
    throw new Error(response?.data?.error || response?.data?.message);
  } catch (error) {
    console.error(error);
    UTILS.errorNotification(errorHandler(error?.error?.message));
    return null;
  }
};

const GetAiAvatar = async (payload) => {
  try {
    APIKit.defaults.timeout = timeout;
    const response = await APIKit.post(
      "creatify-api/get-creatify-avatar",
      payload
    );
    if (response?.data?.success === 1) {
      return response?.data?.data;
    }
    throw new Error(response?.data?.error || response?.data?.message);
  } catch (error) {
    console.error(error);
    UTILS.errorNotification(errorHandler(error?.error?.message));
    return null;
  }
};

const CreateCreatifyVideoFromLink = async (payload) => {
  try {
    APIKit.defaults.timeout = timeout;
    const response = await APIKit.post(
      "creatify-api/create-video-from-link",
      payload
    );
    if (response?.data?.success === 1) {
      return response?.data?.data;
    }
    throw new Error(response?.data?.error || response?.data?.message);
  } catch (error) {
    console.error(error);
    UTILS.errorNotification(errorHandler(error?.error?.message));
    return null;
  }
};

const GetCreatifyVideo = async (payload) => {
  try {
    APIKit.defaults.timeout = timeout;
    const response = await APIKit.post(
      "creatify-api/get-creatify-video",
      payload
    );
    if (response?.data?.success === 1) {
      return response?.data?.data;
    }
    throw new Error(response?.data?.error || response?.data?.message);
  } catch (error) {
    console.error(error);
    UTILS.errorNotification(errorHandler(error?.error?.message));
    return null;
  }
};

const GetCreatifyVideoById = async (payload) => {
  try {
    APIKit.defaults.timeout = timeout;
    const response = await APIKit.post(
      "creatify-api/get-creatify-video-by-id",
      payload
    );
    if (response?.data?.success === 1) {
      return response?.data?.data;
    }
    throw new Error(response?.data?.error || response?.data?.message);
  } catch (error) {
    console.error(error);
    UTILS.errorNotification(errorHandler(error?.error?.message));
    return null;
  }
};

const GetAIScript = async (payload) => {
  try {
    APIKit.defaults.timeout = timeout;
    const response = await APIKit.post(
      "creatify-api/get-ai-script-for-item",
      payload
    );
    if (response?.data?.success === 1) {
      return response?.data?.data;
    }
    throw new Error(response?.data?.error || response?.data?.message);
  } catch (error) {
    console.error(error);
    UTILS.errorNotification(errorHandler(error?.error?.message));
    return null;
  }
};

const useGetCreatifyVideoById = (id, status) => {
  const fetcher = () => GetCreatifyVideoById({ id });
  return useSWR(id ? id : null, fetcher, {
    refreshInterval: status ? 63000 : 24 * 60 * 60 * 1000,
    revalidateOnFocus: true,
    refreshWhenHidden: false, // Allow polling even if tab is hidden
    refreshWhenOffline: true, // Allow polling even if the user is offline
    revalidateOnMount: true, // Always revalidate when the hook is mounted
    revalidateOnReconnect: true, // Revalidate when the user is back online
    revalidateOnWindowFocus: true,
  });
};

export {
  CreateCreatifyLinkWithParams,
  GetAiAvatar,
  CreateCreatifyVideoFromLink,
  GetCreatifyVideo,
  GetCreatifyVideoById,
  useGetCreatifyVideoById,
  GetAIScript,
};
